import { Component, OnInit } from '@angular/core';
import { FlashMessagesService } from "angular2-flash-messages";
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { ConfirmationDialogComponent } from "../../shared/confirmation-dialog/confirmation-dialog.component";
import { CommonService } from "../../_services/common.service";
import { VendorService } from '../../_services/vendor.service';
import { VendorFormComponent } from '../vendor-form/vendor-form.component';

@Component({
  selector: 'app-vendor-list',
  templateUrl: './vendor-list.component.html',
  styleUrls: ['./vendor-list.component.css']
})
export class VendorListComponent implements OnInit {

  public vendorsList: Array<any> = [];
  public loading = false;
  public total = 0;
  public pagesToShow = 10;
  public page = 1;
  public limit = 50;
  public vendorOptions: any = {};
  public search: string = "";
  public sortColumnName = "created_at";
  public sortDirection = "desc";
  public filterVendorText: string = '';

  constructor(private CommonService: CommonService,
    private _flashMessagesService: FlashMessagesService,
    private router: Router,
    private vendorService: VendorService,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.getVendorList();
  }

  getVendorList() {
    this.loading = true;
    this.vendorOptions = {
      page: this.page,
      limit: this.limit,
      search: this.filterVendorText,
      orderBy: this.sortColumnName,
      direction: this.sortDirection
    };

    this.vendorService.getList(this.vendorOptions).subscribe({
      next: (res) => {
        this.loading = false;
        if (res.status && res.data) {
          this.vendorsList = res.data.records;
          this.total = res.data.total;
        }
      },
      error: (err) => {
        console.error('Failed to load vendors list', err);
        this.loading = false;
      }
    });
  }

  openVendorDialog(vendor: any): void {
    const dialogRef = this.dialog.open(VendorFormComponent, {
      width: '600px',
      data: { vendor: vendor || null }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.status) {
        this.getVendorList();
      }
    });
  }

  vendorDeleteDialog(id: string): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "250px",
      data: {
        name: "Admin",
        message: "Are you sure you want to delete this Vendor",
        manageData: { vendor_id: id }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.vendor_id) {
        const data = {
          vendor_id: result.vendor_id
        };

        this.vendorService.delete(data).subscribe({
          next: (res) => {
            this.loading = false;
            if (res.status) {
              this._flashMessagesService.show("Vendor deleted successfuly!", {
                cssClass: "alert-success",
                timeout: 5000
              });

              this.getVendorList();
            }
          },
          error: (err) => {
            this.loading = false;
          }
        });
      }
    });
  }

  updateVendorStatus = function (id) {
    const data = {
      vendor_id: id
    };

    this.vendorService.status(data).subscribe({
      next: (res) => {
        if (res.status) {
          this._flashMessagesService.show("Status updated successfuly!", {
            cssClass: "alert-success",
            timeout: 5000
          });
        }
      },
      error: (err) => {
        console.error('Failed to update status', err);
      }
    });
  }

  isEnabled(check_val) {
    return check_val == 1 ? true : false;
  }

  filterVendor(): void {
    this.page = 1;
    this.total = 0;
    this.getVendorList();
  }

  clearFilterVendor(): void {
    this.filterVendorText = "";
    this.page = 1;
    this.total = 0;
    this.getVendorList();
  }

  goToPage(n: number): void {
    this.page = n;
    this.getVendorList();
  }

  onNext(): void {
    this.page++;
    this.getVendorList();
  }

  onPrev(): void {
    this.page--;
    this.getVendorList();
  }

  goSort($event) {
    this.sortColumnName = $event.columnName;
    this.sortDirection = $event.sortDirection;
    this.getVendorList();
  }

  clickToGo(pathUrl){
    if(pathUrl == 'invoices' || pathUrl == 'dashboard'){
      this.loading = true;
      this.router.navigate([pathUrl]);
    }
  }

  redirectToGo(pathUrl){
    if(pathUrl == 'po/orders'){
      this.loading = true;
      this.router.navigate([pathUrl]);
    }
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/vendor-list/vendor-list.component.ts